// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-row {
    background-color: #111827;
    display: flex;
}

.navIconDIV {
    overflow: hidden;
    flex-shrink: 0;
    padding: 8px 0;
}

.navItem {
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 8px;
    margin: 2px 4px;
    transition: all 0.3s ease;
}

    .navItemDIV {
        padding: 8px 0
    }

    .navItem.icon {
        width: 48px;
        justify-content: center;
    }

.icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.navItem > p {
    margin: 0 16px;
}

.navText {
    position: absolute;
    bottom: 0;
    transform: translateY(50%) rotate(270deg);
    transform-origin: 0 50%;
    cursor: default;
    color: #f5f5f5;
    transition: color 0.3s ease;
    font-family: Inter;
}

.navTextLight {
    color: #e0e0e0;
}

.over {
    position: absolute;
    height: 100%;
    z-index: 99;
    display: flex;
}

.side {
    position: relative;
}

.overlay {
    flex: 1 1 auto;
    background-color: rgba(0,0,0,0.5);
    cursor: pointer;
}

.navItem:hover {
    background-color: #29303D;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.selected-no-border {
    background-color: #0F3443;
    color: #38EF7D;
}

.scroll {
    max-height: 100vh;
    overflow-y: auto;
}

    .scroll::-webkit-scrollbar {
        width: 6px;
    }

    .scroll::-webkit-scrollbar-thumb {
        background-color: #29303D;
        border-radius: 3px;
    }

    .scroll::-webkit-scrollbar-track {
        background-color: #111827;
    }

mat-icon {
    transition: transform 0.3s ease;
}

.navItem:hover mat-icon {
    transform: scale(1.1);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/navigationcontrol/navigation.tabs.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;IAEI;QACI;IACJ;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;AAEJ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,yCAAyC;IACzC,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".flex-row {\n    background-color: #111827;\n    display: flex;\n}\n\n.navIconDIV {\n    overflow: hidden;\n    flex-shrink: 0;\n    padding: 8px 0;\n}\n\n.navItem {\n    height: 48px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    flex-shrink: 0;\n    border-radius: 8px;\n    margin: 2px 4px;\n    transition: all 0.3s ease;\n}\n\n    .navItemDIV {\n        padding: 8px 0\n    }\n\n    .navItem.icon {\n        width: 48px;\n        justify-content: center;\n    }\n\n.icon-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.navItem > p {\n    margin: 0 16px;\n}\n\n.navText {\n    position: absolute;\n    bottom: 0;\n    transform: translateY(50%) rotate(270deg);\n    transform-origin: 0 50%;\n    cursor: default;\n    color: #f5f5f5;\n    transition: color 0.3s ease;\n    font-family: Inter;\n}\n\n.navTextLight {\n    color: #e0e0e0;\n}\n\n.over {\n    position: absolute;\n    height: 100%;\n    z-index: 99;\n    display: flex;\n}\n\n.side {\n    position: relative;\n}\n\n.overlay {\n    flex: 1 1 auto;\n    background-color: rgba(0,0,0,0.5);\n    cursor: pointer;\n}\n\n.navItem:hover {\n    background-color: #29303D;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.selected-no-border {\n    background-color: #0F3443;\n    color: #38EF7D;\n}\n\n.scroll {\n    max-height: 100vh;\n    overflow-y: auto;\n}\n\n    .scroll::-webkit-scrollbar {\n        width: 6px;\n    }\n\n    .scroll::-webkit-scrollbar-thumb {\n        background-color: #29303D;\n        border-radius: 3px;\n    }\n\n    .scroll::-webkit-scrollbar-track {\n        background-color: #111827;\n    }\n\nmat-icon {\n    transition: transform 0.3s ease;\n}\n\n.navItem:hover mat-icon {\n    transform: scale(1.1);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
